// extracted by mini-css-extract-plugin
export var indeterminate = "_28-6";
export var md = "_28-5";
export var semantic = "_28-7";
export var sm = "_28-4";
export var text = "_28-8";
export var toggleControl = "_28-0";
export var toggleInput = "_28-1";
export var toggleSwitch = "_28-2";
export var xs = "_28-3";